export const NumberedList = ({ items }: { items: React.ReactNode[] }) => {
  return (
    <ol>
      {items.map((item, index) => (
        <li key={index} className='flex items-start gap-4 mb-4'>
          <span className='w-[30px] h-[30px] rounded-full bg-secondary-brand-50 text-brand-500 flex items-center justify-center font-semibold flex-shrink-0'>
            {index + 1}
          </span>
          <span className='flex-grow pt-0.5'>{item}</span>
        </li>
      ))}
    </ol>
  );
};
